import breezeLogoUrl from "../../../../icons/icon_files/breeze_full_logo.svg";
import { TimePoint } from "../../../../utils/constants";
// Common time point options for trend comparison across all widgets
export const baseTimePointOptions = {
  [TimePoint.THIRTY_DAYS]: "30 days ago",
  [TimePoint.THREE_MONTHS]: "3 months ago",
  [TimePoint.SIX_MONTHS]: "6 months ago",
  [TimePoint.ONE_YEAR]: "1 year ago",
};

export const timePointOptions = [
  { label: "Current", key: TimePoint.LATEST, apiKey: TimePoint.LATEST },
  {
    label: "30 days ",
    key: TimePoint.THIRTY_DAYS,
    apiKey: TimePoint.THIRTY_DAYS,
  },
  {
    label: "3 months ",
    key: TimePoint.THREE_MONTHS,
    apiKey: TimePoint.THREE_MONTHS,
  },
  {
    label: "6 months ",
    key: TimePoint.SIX_MONTHS,
    apiKey: TimePoint.SIX_MONTHS,
  },
  { label: "Year ", key: TimePoint.ONE_YEAR, apiKey: TimePoint.ONE_YEAR },
];

export const createTrendSortMenuItems = (
  baseTimePoint,
  setBaseTimePoint,
  trendData,
  icons,
  trackEvent,
  key,
  subKey = null,
  filterOptions = null
) => {
  if (!trendData) return [];
  return [
    {
      title: "View trend from",
      key: "view-trend-from" + key,
      submenuTitle: "Select time period",
      disabled: false,
      trailingIcon: icons.chevronRightIcon,
      submenu: timePointOptions
        .filter((option) =>
          filterOptions ? !filterOptions.includes(option.key) : true
        )
        .map((option) => ({
          title: option.label,
          key: option.key,
          selected: baseTimePoint === option.apiKey,
          onclick: () => {
            trackEvent &&
              trackEvent(
                "User clicked on trend selector option: " + option.label
              );
            setBaseTimePoint(option.apiKey);
          },
          disabled:
            !trendData ||
            Object.keys(trendData).length === 0 ||
            (trendData &&
              option.key &&
              (subKey
                ? trendData[option.key] &&
                  trendData[option.key][subKey] === null
                : trendData[option.key] === null)),
        })),
    },
  ];
};

export const calculateTrendData = (
  currentData,
  baseData,
  type = "entities"
) => {
  if (!currentData || !baseData) return {};

  const trends = {};

  Object.keys(currentData).forEach((entityType) => {
    const current = currentData[entityType];
    const base = baseData[entityType];

    if (current && base) {
      // Calculate entity count trend
      const entitiesDiff = parseInt((current[type] - base[type]).toFixed(0));
      const entitiesPercentChange =
        base[type] > 0 ? ((entitiesDiff / base[type]) * 100).toFixed(0) : 0;

      // Calculate coverage trend
      const coverageDiff = parseInt(
        (current.coverage - base.coverage).toFixed(0)
      );
      const coveragePercentChange =
        base.coverage > 0
          ? ((coverageDiff / base.coverage) * 100).toFixed(0)
          : 0;

      trends[entityType] = {
        [type]: {
          current: current[type],
          previous: base[type],
          diff: entitiesDiff,
          percentChange: entitiesPercentChange,
          isPositive: entitiesDiff >= 0,
        },
        coverage: {
          current: current.coverage,
          previous: base.coverage,
          diff: coverageDiff,
          percentChange: coveragePercentChange,
          isPositive: coverageDiff >= 0,
        },
      };
    }
  });

  return trends;
};

export const createPdfHeader = (title, subtitle = "") => {
  const header = document.createElement("div");
  header.style.cssText = `
    text-align: center;
    margin-bottom: 24px;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 16px;
  `;

  const titleElement = document.createElement("h1");
  titleElement.textContent = title;
  titleElement.style.cssText = `
    margin: 0 0 12px 0;
    font-size: 24px;
    font-weight: bold;
    font-family: "Poppins", sans-serif;
    color: #333;
  `;

  if (subtitle) {
    const subtitleElement = document.createElement("h2");
    subtitleElement.textContent = subtitle;
    subtitleElement.style.cssText = `
      margin: 0 0 12px 0;
      font-size: 16px;
      font-weight: normal;
      color: #666;
    `;
    header.appendChild(subtitleElement);
  }

  const date = document.createElement("p");
  date.textContent = `Generated on: ${new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })}`;
  date.style.cssText = `
    margin: 0;
    font-size: 14px;
    color: #666;
  `;

  header.appendChild(titleElement);
  header.appendChild(date);

  return header;
};
export const addBreezeLogoOnTop = (fullElement) => {
  return new Promise((resolve, reject) => {
    // Create a canvas to convert SVG to PNG for better PDF compatibility
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Set high resolution for crisp rendering
    const logoWidth = 460; // 2x the display size for high DPI
    const logoHeight = 80;

    canvas.width = logoWidth;
    canvas.height = logoHeight;

    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      try {
        // Draw the SVG to canvas with white background
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, logoWidth, logoHeight);
        ctx.drawImage(img, 0, 0, logoWidth, logoHeight);

        // Convert canvas to high-quality PNG data URL
        const pngDataUrl = canvas.toDataURL("image/png", 1.0);

        // Create the final img element with PNG data
        const logoImg = document.createElement("img");
        logoImg.src = pngDataUrl;
        logoImg.alt = "Breeze Logo";
        logoImg.style.width = "230px";
        logoImg.style.height = "40px";
        logoImg.style.imageRendering = "high-quality";
        logoImg.style.imageRendering = "-webkit-optimize-contrast";

        const logoContainer = document.createElement("div");
        logoContainer.style.display = "flex";
        logoContainer.style.justifyContent = "center";
        logoContainer.style.marginBottom = "16px";
        logoContainer.appendChild(logoImg);

        fullElement.appendChild(logoContainer);
        resolve();
      } catch (error) {
        console.warn(
          "Failed to convert SVG logo to PNG, using original SVG:",
          error
        );
        // Fallback to original SVG implementation
        const fallbackImg = document.createElement("img");
        fallbackImg.crossOrigin = "anonymous";
        fallbackImg.src = breezeLogoUrl;
        fallbackImg.alt = "Breeze Logo";
        fallbackImg.style.width = "230px";
        fallbackImg.style.height = "40px";

        const logoContainer = document.createElement("div");
        logoContainer.style.display = "flex";
        logoContainer.style.justifyContent = "center";
        logoContainer.appendChild(fallbackImg);

        fullElement.appendChild(logoContainer);
        resolve();
      }
    };

    img.onerror = (error) => {
      console.warn("Failed to load SVG logo, using fallback:", error);
      // Fallback implementation
      const fallbackImg = document.createElement("img");
      fallbackImg.crossOrigin = "anonymous";
      fallbackImg.src = breezeLogoUrl;
      fallbackImg.alt = "Breeze Logo";
      fallbackImg.style.width = "230px";
      fallbackImg.style.height = "40px";

      const logoContainer = document.createElement("div");
      logoContainer.style.display = "flex";
      logoContainer.style.justifyContent = "center";
      logoContainer.style.marginBottom = "16px";
      logoContainer.appendChild(fallbackImg);

      fullElement.appendChild(logoContainer);
      resolve();
    };

    img.src = breezeLogoUrl;
  });
};

export const createPdfContainer = async () => {
  const container = document.createElement("div");
  container.style.cssText = `
    display: flex;
    flex-direction: column;
    gap: 8x;
    width: 100%;
    background-color: #ffffff;
    padding: 32px 16px;
  `;
  await addBreezeLogoOnTop(container);
  return container;
};

export const enhanceAssetCardShadows = (clonedElement) => {
  const assetCards = clonedElement.querySelectorAll(
    'div[style*="box-shadow"][style*="border-radius"][style*="padding"]'
  );

  assetCards.forEach((card) => {
    if (card instanceof HTMLElement) {
      const currentShadow = card.style.boxShadow;
      if (
        currentShadow &&
        currentShadow !== "none" &&
        currentShadow.includes("rgba")
      ) {
        card.style.webkitBoxShadow = currentShadow;
        card.style.mozBoxShadow = currentShadow;
        if (!card.style.border || card.style.border === "none") {
          card.style.border = "1px solid rgba(0, 0, 0, 0.05)";
        }
      }
    }
  });
};

export const createPdfConfig = (filename, contentWidth, contentHeight) => {
  const pixelsToMm = 0.264583;
  const contentWidthMm = contentWidth * pixelsToMm + 20;
  const contentHeightMm = contentHeight * pixelsToMm + 20;

  return {
    filename,
    html2canvas: {
      useCORS: true,
      scale: 2,
      backgroundColor: "#ffffff",
      logging: false,
      allowTaint: true,
      width: contentWidth,
      height: contentHeight,
      foreignObjectRendering: true,
      removeContainer: false,
      imageTimeout: 0,
      onclone: (clonedDoc, element) => {
        const assetCardElements = element.querySelectorAll(
          'div[style*="box-shadow"][style*="border-radius"][style*="padding"]'
        );
        assetCardElements.forEach((el) => {
          if (el instanceof HTMLElement) {
            const currentShadow = el.style.boxShadow;
            if (
              currentShadow &&
              currentShadow !== "none" &&
              currentShadow.includes("rgba")
            ) {
              el.style.webkitBoxShadow = currentShadow;
              el.style.mozBoxShadow = currentShadow;
              if (el.style.minWidth && el.style.minHeight) {
                el.style.filter = "drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))";
              }
            }
          }
        });
      },
    },
    jsPDF: {
      unit: "mm",
      format: [contentWidthMm, contentHeightMm],
      orientation: contentWidthMm > contentHeightMm ? "landscape" : "portrait",
    },
  };
};

export const measureContentForPdf = async (element) => {
  // Temporarily add to DOM to measure dimensions
  element.style.position = "absolute";
  element.style.left = "-9999px";
  element.style.top = "-9999px";
  element.style.visibility = "hidden";
  document.body.appendChild(element);

  // Wait for rendering to complete
  await new Promise((resolve) => setTimeout(resolve, 100));

  // Measure the actual content dimensions
  const rect = element.getBoundingClientRect();
  const contentWidth = Math.max(rect.width, 800); // Minimum width
  const contentHeight = Math.max(rect.height, 600); // Minimum height

  // Remove from DOM
  document.body.removeChild(element);

  // Reset positioning for PDF generation
  element.style.position = "static";
  element.style.left = "auto";
  element.style.top = "auto";
  element.style.visibility = "visible";

  return { contentWidth, contentHeight };
};
